var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page noselect" },
    [
      _c("div", { staticClass: "fixBg maxw" }),
      _c(
        "div",
        { staticStyle: { "z-index": "2", position: "relative" } },
        [
          _c("div", { staticClass: "spacer-40" }),
          _c("div", { staticClass: "spacer-40" }),
          _c(
            "v-container",
            { staticClass: "cc", attrs: { "grid-list-xl": "" } },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _vm.$store.state.enableOrderModeSelection
                    ? _c(
                        "v-flex",
                        { staticClass: "text-center", attrs: { xs12: "" } },
                        [
                          _c(
                            "div",
                            { staticClass: "mobile pa-3" },
                            [
                              _c("OrderModeSwitcher", {
                                attrs: {
                                  availableModes: _vm.availableOrderModes,
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "tablet pl-2 pr-2 pt-4 pb-7" },
                            [
                              _c("OrderModeSwitcher", {
                                attrs: {
                                  availableModes: _vm.availableOrderModes,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "v-flex",
                    { staticClass: "pb-3 d-flex", attrs: { xs6: "" } },
                    [
                      _c("CategoryCard", {
                        staticClass: "pointer",
                        attrs: {
                          label: "Speisen",
                          nomargin: false,
                          icon: "mdi-silverware-fork-knife",
                        },
                        nativeOn: {
                          "&click": function ($event) {
                            return _vm.gotoSpeisen.apply(null, arguments)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { staticClass: "pb-3 d-flex", attrs: { xs6: "" } },
                    [
                      _c("CategoryCard", {
                        staticClass: "pointer",
                        attrs: {
                          label: "Getränke",
                          nomargin: false,
                          icon: "mdi-beer",
                        },
                        nativeOn: {
                          "&click": function ($event) {
                            return _vm.gotoDrinks.apply(null, arguments)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { staticClass: "pb-3 d-flex", attrs: { xs12: "" } },
                    [
                      _c("CategoryCard", {
                        staticClass: "pointer",
                        attrs: {
                          label: "Abholzeiten",
                          nomargin: false,
                          icon: "mdi-clock-outline",
                        },
                        nativeOn: {
                          "&click": function ($event) {
                            return _vm.$ebus.$emit("goto", {
                              name: "Abholzeiten",
                            })
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { staticClass: "pb-3 d-flex", attrs: { xs12: "" } },
                    [
                      _c("CategoryCard", {
                        staticClass: "pointer",
                        attrs: {
                          label: "Über TIPSI",
                          nomargin: false,
                          icon: "mdi-information",
                        },
                        nativeOn: {
                          "&click": function ($event) {
                            return _vm.$ebus.$emit("gotoPage", "Über TIPSI")
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { staticClass: "pb-3 d-flex", attrs: { xs12: "" } },
                    [
                      _c("CategoryCard", {
                        staticClass: "pointer",
                        attrs: {
                          label: "Instagram",
                          nomargin: false,
                          icon: "mdi-instagram",
                        },
                        nativeOn: {
                          "&click": function ($event) {
                            return _vm.$ebus.$emit(
                              "gotoWebsite",
                              "https://www.instagram.com/tipsi_kb/"
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.$store.getters.lastOrders.length > 0
                    ? _c(
                        "v-flex",
                        { staticClass: "pb-3 d-flex", attrs: { xs12: "" } },
                        [
                          _c("CategoryCard", {
                            staticClass: "pointer",
                            attrs: {
                              label: "Meine Bestellungen",
                              nomargin: false,
                              icon: "mdi-history",
                            },
                            nativeOn: {
                              "&click": function ($event) {
                                return _vm.gotoLastOrders.apply(null, arguments)
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c("div", { staticClass: "logoPadding" }),
            ],
            1
          ),
        ],
        1
      ),
      _c("FixBasket"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }